import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-plant",
    templateUrl: "./go-plant.component.html"
})


export class GoPlantComponent extends GoBaseComponent {
  UI_TEXTS = UI_TEXTS;


    constructor() {
        super(GO_COMPONENTS.PLANT);
    }


    get action() {
        return this.component["action"];
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-plant/go-plant.component.ts